import {Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Switch from 'flarum/common/components/Switch';
import FieldList from '../fields/FieldList';
import ValueHistory from '../utils/ValueHistory';
import Uploader from '../utils/Uploader';
import SaveControls from '../components/SaveControls';
import {FormTemplate, SubmissionPayload, SubmissionValidationErrors} from '../models/JsonTypes';

export default class DebugPage extends Page {
    configuration!: FormTemplate
    submission!: SubmissionPayload
    errors!: SubmissionValidationErrors
    history: ValueHistory | null = null
    horizontal: boolean = false

    oninit(vnode: Vnode) {
        super.oninit(vnode);

        m.request({
            url: app.forum.attribute('apiUrl') + '/formulaire/debug',
            method: 'GET',
        }).then((data: any) => {
            this.configuration = data.configuration;
            this.submission = data.submission;
            this.errors = data.errors;
            data.store.forEach((model: any) => {
                app.store.pushObject(model);
            });

            this.history = new ValueHistory(this.configuration);
        });
    }

    view() {
        if (!this.history) {
            return m('i', '...');
        }

        const list = new FieldList({
            configs: this.history.value,
            submission: this.submission,
            uploader: { // Fake object so that the form can render
                uploading: false,
            } as Uploader,
            onchange: () => {
                this.history!.save();
            },
            expertMode: true,
            validationErrors: this.errors,
        });

        return m('.FormulaireDebugPage', {
            className: this.horizontal ? 'Formulaire-horizontal-layout' : '',
        }, [
            m('div', [
                Switch.component({
                    state: this.horizontal,
                    onchange: (value: boolean) => {
                        this.horizontal = value;
                    },
                }, 'Horizontal'),
                m('pre', JSON.stringify(this.history.value, null, 4)),
                m('pre', JSON.stringify(this.submission, null, 4)),
            ]),
            m('div', [
                list.configureView(),
                m(SaveControls, {
                    history: this.history,
                    floating: true,
                }),
            ]),
            m('div', list.listView()),
            m('div', list.listView(true)),
        ]);
    }
}
